import { render, staticRenderFns } from "./BulkUpdateItem.vue?vue&type=template&id=f11b5570&scoped=true&"
import script from "./BulkUpdateItem.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11b5570",
  null
  
)

export default component.exports